export default __webpack_public_path__ + "static/media/headphone-audio.2fce5235.svg";